import React from 'react';

import i18n from '@client/utils/i18n';
import { LinkTypeChip } from '@ledium/ui-common';
import { Alert, Box, Typography } from '@mui/material';

interface ScenarioRow {
    label: string;
    description: string;
    linkType?: string;
}

function ZoneWizardStep1() {
    const scenarios: ScenarioRow[] = [
        {
            label: i18n('copy') as string,
            description: i18n('copy_zone_copy_description') as string
        },
        {
            label: i18n('copy_zone_link_sync_label') as string,
            description: i18n('copy_zone_link_sync_sublabel') as string,
            linkType: 'mirror'
        },
        {
            label: i18n('copy_zone_link_independent_label') as string,
            description: i18n('copy_zone_link_independent_sublabel') as string,
            linkType: 'independent'
        }
    ];

    return (
        <Box>
            <Typography paragraph>{i18n('copy_zone_step1_description')}</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
                {scenarios.map((scenario) => (
                    <Box key={scenario.label}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                            <Typography variant="subtitle2">{scenario.label}</Typography>
                            {scenario.linkType && <LinkTypeChip type={scenario.linkType} />}
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                            {scenario.description}
                        </Typography>
                    </Box>
                ))}
            </Box>
            <Alert severity="info">{i18n('copy_zone_step1_note')}</Alert>
        </Box>
    );
}

export default ZoneWizardStep1;
